// @systeme: contrat
// Les textes légaux (CGU, CGV, politique de confidentialité) : le serveur les sert avec
// leur version, le client les affiche. Une version est une date.
import { z } from 'zod';
import { SchemaCleJuridique } from '../enumerations.js';
export const SchemaTexteJuridique = z.object({
    cle: SchemaCleJuridique,
    titre: z.string(),
    version: z.string(),
    /** Le texte, en Markdown léger (titres, paragraphes, listes). */
    contenu: z.string(),
});
//# sourceMappingURL=juridique.js.map